module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "structure-nxt"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("© Copyright 2020 June"), _c('span', {
    staticClass: "nobreak"
  }), _vm._v("Cotner")]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Cover Design and Interior Layout Design: Jermaine")]), _c('span', {
    staticClass: "nobreak CharOverride-9"
  }), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Lau")])]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Published by Mango Publishing, a division of Mango Media")]), _c('span', {
    staticClass: "nobreak CharOverride-9"
  }), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Mango is an active supporter of authors’ rights to free speech and artistic expression in their books. The purpose of copyright is to encourage authors to produce exceptional works that enrich our culture and our open society. Uploading or distributing photos, scans or any content from this book without prior permission is theft of the author’s intellectual property. Please honor the author’s work as you would your own. Thank you in advance for respecting our authors’ rights.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("For permission requests, please contact the publisher")]), _c('span', {
    staticClass: "nobreak CharOverride-9"
  }), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("at:")])]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Mango Publishing Group"), _c('br'), _vm._v("2850 Douglas Road, 2nd Floor"), _c('br'), _vm._v("Coral Gables, FL 33134 USA"), _c('br')]), _c('a', {
    attrs: {
      "href": "mailto:info@mango.bz"
    }
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("info@mango.bz")])])]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("For special orders, quantity sales, course adoptions and corporate sales, please email the publisher at ")]), _c('a', {
    attrs: {
      "href": "mailto:sales@mango.bz"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("sales@mango.bz")])]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v(". For trade and wholesale sales, please contact Ingram Publisher Services at ")]), _c('a', {
    attrs: {
      "href": "mailto:customer.service@ingramcontent.com"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("customer.service@ingramcontent.com")])]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v(" or +1.800.509.4887.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Hey! It’s Your Day: Inspirational Quotes & Affirmations to Live")]), _c('span', {
    staticClass: "nobreak CharOverride-11"
  }), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("By")])]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ISBN: (p) 978-1-64250-393-7 (e) 978-1-64250-394-4")])]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("BISAC: REF019000—REFERENCE / Quotations")])]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("LCCN: 2020946324")])]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("No part of this book may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means without the prior written permission of the publisher. Printed in the United States of")]), _c('span', {
    staticClass: "nobreak CharOverride-9"
  }), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("America.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d522534","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/97816425039442.vue
// module id = 66
// module chunks = 0